import {
	API_START,
	API_END,
	FETCH_PUBLISH_ACTIVITY_REQUEST,
	SET_PUBLISH_RESULT,
	SET_TEMPLATE_TIMES,
	SET_TEMPLATE_DATES,
	SET_PUBLISH_TEMPLATE,
	SET_PUBLISH_GOODDEAL_TEMPLATE,
	RESET_DATA,
	SET_PUBLISH_DATE,
	CLEAR_PUBLISH_DATE,
	SET_PUBLISH_TIME,
	SET_PUBLISH_EQUIPMENT,
	SET_PUBLISH_CHOICE,
	SET_PROFILE_DETAILS,
	CLEAR_PUBLISH,
	TOGGLE_DISPLAY_PREVIEW,
	SET_COMMUNITY_DETAILS,
	SET_TEMPLATE_CHANNEL_ID,
	SET_SHARE_CHANNEL_ID,
	CLEAR_EQUIPMENT,
	SET_TEMPLATE_NAME,
	CLEAR_TEMPLATE_PHOTO_DATA,
	SET_TEMPLATE_PHOTO_DATA,
	SET_TEMPLATE_VIDEO_ID,
	SET_TEMPLATE_TITLE_FR,
	SET_TEMPLATE_TITLE_EN,
	SET_TEMPLATE_DESCRIPTION_FR,
	SET_TEMPLATE_DESCRIPTION_EN,
	SET_TEMPLATE_ENGLISH,
	SET_TEMPLATE_CATEGORY_NAME_EN,
	SET_TEMPLATE_CATEGORY_NAME_FR,
	CLEAR_TEMPLATE_VALIDATE,
	VALIDATE_TEMPLATE_INPUTS,
	SET_READY_TO_COPY_URL,
	CLEAR_READY_TO_COPY_URL,
	SET_TEMPLATE_THUMBNAIL_URL,
	SET_TEMPLATE_POST_DESCRIPTION_EN,
	SET_TEMPLATE_POST_DESCRIPTION_FR,
	SET_FETCH_SAVE_TEMPLATE,
	SET_DISPLAY_PREVIEW,
	CLEAR_TEMPLATE,
	SET_KEYBOARD_OPEN,
	SET_SHOULD_PROVIDE_CATEGORY,
	SET_POST_PHOTO_DATA,
	SET_TEMPLATE_URL
} from "../actions/types";
import { GROUP_ID_GOODDEAL_ACTIVITY } from "../config/constants";
import { t } from "../services/i18n";

const initialState = {
	isFetching: false,
	data: null,
	template: null,
	dateId: null,
	timeId: null,
	equipmentId: null,
	locationId: null,
	choiceId: null,
	groupId: null,
	ad: null,
	templateDates: {},
	templateTimes: {},
	equipments: {},
	templateChannels: {},
	templateChannelId: null,
	shareChannels: {},
	shareChannelId: null,
	displayTimes: false,
	user: null,
	displayPreview: true,
	name: null,
	nameErrorMsg: null,
	title: null,
	description: null,
	descriptionErrorMsg: null,
	lang: null,
	category: null,
	categoryErrorMsg: null,
	files: [],
	photoUri: null,
	youtubeVideoId: null,
	isEnglish: false,
	clearTemplateValidate: false,
	isValid: false,
	readyToCopyUrl: false,
	saveTemplateResult: null,
	keyboardOpen: false,
	shouldProvideCategory: false,
	url: null,
	urlErrorMsg: null
};

function keepState(state) {
	return {
		...initialState,
		templateDates: state.templateDates,
		templateTimes: state.templateTimes,
		equipments: state.equipments,
		templateChannels: state.templateChannels,
		templateChannelId: state.templateChannelId,
		shareChannels: state.shareChannels,
		shareChannelId: state.shareChannelId,
		user: state.user
	};
}

function validateUrl(url) {
	try {
		new URL(url.startsWith("http") ? url : `https://${url}`);
		return true;
	} catch (_) {
		return false;
	}
}

export default function templateReducer(state = initialState, action = {}) {
	switch (action.type) {
		case API_START:
			if (action.payload === FETCH_PUBLISH_ACTIVITY_REQUEST) {
				return {
					...state,
					isFetching: true,
					data: null
				};
			}
			break;

		case RESET_DATA:
			return {
				...initialState
			};

		case CLEAR_PUBLISH:
		case CLEAR_TEMPLATE:
			return keepState(state);

		case SET_KEYBOARD_OPEN:
			return {
				...state,
				keyboardOpen: action.value
			};

		case SET_SHOULD_PROVIDE_CATEGORY:
			return {
				...state,
				shouldProvideCategory: action.value
			};

		case SET_TEMPLATE_URL:
			return {
				...state,
				url: action.value,
				urlErrorMsg: null
			};

		case SET_TEMPLATE_NAME:
			return {
				...state,
				name: action.value,
				nameErrorMsg: null
			};

		case SET_TEMPLATE_TITLE_FR:
			return {
				...state,
				title: action.value
			};

		case SET_TEMPLATE_TITLE_EN: {
			const { title, ...others } = state.lang?.en || {};

			return {
				...state,
				lang: {
					...(state.lang ?? {}),
					en: {
						title: action.value,
						...(others ?? {})
					}
				}
			};
		}

		case SET_TEMPLATE_DESCRIPTION_FR:
			return {
				...state,
				description: action.value,
				descriptionErrorMsg: null
			};

		case SET_TEMPLATE_DESCRIPTION_EN: {
			const { description, ...others } = state.lang?.en || {};

			return {
				...state,
				lang: {
					...(state.lang ?? {}),
					en: {
						description: action.value,
						...(others ?? {})
					}
				}
			};
		}

		case CLEAR_TEMPLATE_PHOTO_DATA:
			return {
				...state,
				files: [],
				photoUri: null,
				youtubeVideoId: null,
				displayPreview: true
			};

		case SET_POST_PHOTO_DATA:
			return {
				...state,
				displayPreview: true
			};

		case SET_TEMPLATE_PHOTO_DATA:
			return {
				...state,
				displayPreview: true,
				files: action.files ? action.files : [],
				photoUri: action.value,
				youtubeVideoId: null
			};

		case SET_TEMPLATE_THUMBNAIL_URL:
			return {
				...state,
				files: [],
				photoUri: action.value,
				displayPreview: true
			};

		case SET_TEMPLATE_VIDEO_ID:
			return {
				...state,
				files: [],
				photoUri: null,
				youtubeVideoId: action.value
			};

		case SET_TEMPLATE_POST_DESCRIPTION_FR:
			return {
				...state,
				postDescription: action.value
			};

		case SET_TEMPLATE_POST_DESCRIPTION_EN: {
			const { postDescription, ...others } = state.lang?.en || {};

			return {
				...state,
				lang: {
					...(state.lang ?? {}),
					en: {
						postDescription: action.value,
						...(others ?? {})
					}
				}
			};
		}

		case SET_TEMPLATE_ENGLISH:
			return {
				...state,
				isEnglish: action.payload
			};

		case CLEAR_TEMPLATE_VALIDATE:
			return {
				...state,
				clearTemplateValidate: true,
				isValid: false,
				nameErrorMsg: null,
				descriptionErrorMsg: null,
				urlErrorMsg: null,
				categoryErrorMsg: null
			};

		case VALIDATE_TEMPLATE_INPUTS:
			const urlErrorMsg =
				state.url && state.url.trim().length > 0 && !validateUrl(state.url)
					? t("template:urlbadformat")
					: null;
			const descriptionErrorMsg =
				!state.photoUri && (state.description?.trim()?.length || 0) === 0
					? t("template:descriptionmandatory")
					: null;
			const nameErrorMsg =
				(state.name?.trim()?.length || 0) === 0
					? t("template:namemandatory")
					: null;
			const categoryErrorMsg =
				state.shouldProvideCategory &&
				(state.category?.name?.trim()?.length || 0) === 0
					? t("template:categorymandatory")
					: null;
			return {
				...state,
				clearTemplateValidate: false,
				descriptionErrorMsg,
				nameErrorMsg,
				categoryErrorMsg,
				urlErrorMsg,
				isEnglish: descriptionErrorMsg ? false : state.isEnglish,
				isValid:
					!descriptionErrorMsg &&
					!categoryErrorMsg &&
					!nameErrorMsg &&
					!urlErrorMsg
			};

		case SET_READY_TO_COPY_URL:
			return {
				...state,
				readyToCopyUrl: true
			};

		case CLEAR_READY_TO_COPY_URL:
			return {
				...state,
				readyToCopyUrl: false
			};

		case SET_TEMPLATE_CATEGORY_NAME_EN:
			return {
				...state,
				category: {
					...(state.category ?? {}),
					lang: { ...state.category.lang, en: { name: action.value } }
				}
			};

		case SET_TEMPLATE_CATEGORY_NAME_FR:
			return {
				...state,
				categoryErrorMsg: null,
				category: {
					...(state.category ?? {}),
					name: action.value
				}
			};

		case TOGGLE_DISPLAY_PREVIEW:
			return {
				...state,
				displayPreview: !state.displayPreview
			};

		case SET_DISPLAY_PREVIEW:
			return {
				...state,
				displayPreview: action.value
			};

		case SET_PROFILE_DETAILS:
			return {
				...state,
				user: action.payload
			};

		case SET_FETCH_SAVE_TEMPLATE:
			return {
				...state,
				saveTemplateResult: action.payload
			};

		case SET_PUBLISH_DATE: {
			const displayTimes = Boolean(
				action.payload &&
					state.templateDates[action.payload].name !== "Maintenant" &&
					state.templateDates[action.payload].name !== "À définir ensemble"
			);
			return {
				...state,
				dateId: action.payload,
				timeId: displayTimes
					? state.timeId
						? state.timeId
						: Object.keys(state.templateTimes)[0]
					: null,
				displayTimes
			};
		}

		case CLEAR_PUBLISH_DATE:
			return {
				...state,
				dateId: null,
				timeId: null
			};

		case SET_PUBLISH_TIME:
			return {
				...state,
				timeId: action.payload
			};

		case SET_PUBLISH_EQUIPMENT:
			let locationId = null;
			if (
				action.payload &&
				state.equipments[action.payload].name === "À mon emplacement" &&
				state.user.lastBooking
			) {
				locationId = state.user.lastBooking.locationId;
			}
			return {
				...state,
				equipmentId: action.payload,
				locationId
			};

		case CLEAR_EQUIPMENT:
			return {
				...state,
				equipmentId: null,
				locationId: null
			};

		case SET_PUBLISH_CHOICE:
			return {
				...state,
				choiceId: action.payload
			};

		case SET_TEMPLATE_DATES:
			return {
				...state,
				templateDates: action.entities.templateDates
			};

		case SET_TEMPLATE_TIMES:
			return {
				...state,
				templateTimes: action.entities.templateTimes
			};

		case SET_TEMPLATE_CHANNEL_ID:
			return {
				...state,
				templateChannelId: action.payload
			};

		case SET_SHARE_CHANNEL_ID:
			return {
				...state,
				shareChannelId: action.payload
			};

		case SET_COMMUNITY_DETAILS:
			const community = Object.values(action.entities?.communities || {})[0];
			if (
				!community?.organizationId &&
				community?.communitytype !== "Organization"
			)
				return { ...state, equipments: action.entities.equipments };
			const templateChannels = Object.values(action.entities.channels || {})
				.filter(
					channel =>
						channel.channeltype === "TemplateChannel" ||
						(community.communitytype === "Organization" &&
							channel.channeltype === "OrganizationTemplateChannel")
				)
				.map(({ _id, communityId: { name } }) => ({ id: _id, name }));
			const shareChannels = Object.values(action.entities.channels || {})
				.filter(channel => channel.channeltype === "ShareChannel")
				.map(({ _id, communityId: { name } }) => ({ id: _id, name }));

			return {
				...state,
				templateChannels: templateChannels?.length ? templateChannels : {},
				shareChannels: shareChannels?.length ? shareChannels : {},
				templateChannelId: templateChannels?.[0]?.id || null,
				shareChannelId: shareChannels?.[0]?.id || null,
				equipments: action.entities.equipments
			};

		case SET_PUBLISH_GOODDEAL_TEMPLATE: {
			if (action.template) {
				const { template, choiceId, ad } = action;
				const { dateId, timeId, equipmentId } = template;
				const displayTimes = Boolean(
					dateId &&
						state.templateDates[dateId].name !== "Maintenant" &&
						state.templateDates[dateId].name !== "À définir ensemble"
				);
				let locationId = null;
				if (
					equipmentId &&
					state.equipments[equipmentId].name === "À mon emplacement" &&
					state.user.lastBooking
				) {
					locationId = state.user.lastBooking.locationId;
				}
				return {
					...state,
					template,
					groupId: GROUP_ID_GOODDEAL_ACTIVITY,
					dateId,
					timeId,
					equipmentId,
					displayTimes,
					locationId,
					choiceId,
					ad
				};
			}
			break;
		}

		case SET_PUBLISH_TEMPLATE: {
			if (action.payload) {
				const template = action.payload;
				const { dateId, timeId, equipmentId } = template;
				const displayTimes = Boolean(
					dateId &&
						state.templateDates[dateId].name !== "Maintenant" &&
						state.templateDates[dateId].name !== "À définir ensemble"
				);
				let locationId = null;
				if (
					equipmentId &&
					state.equipments[equipmentId] &&
					state.equipments[equipmentId].name === "À mon emplacement" &&
					state.user.lastBooking
				) {
					locationId = state.user.lastBooking.locationId;
				}
				return {
					...state,
					template,
					groupId: template.type.toLowerCase(),
					dateId,
					timeId,
					equipmentId,
					displayTimes,
					locationId
				};
			}
			break;
		}

		case SET_PUBLISH_RESULT:
			return {
				...keepState(state),
				data: action.payload
			};

		case API_END:
			if (action.payload === FETCH_PUBLISH_ACTIVITY_REQUEST) {
				return {
					...state,
					isFetching: false
				};
			}
			break;
		default:
			return state;
	}
	return state;
}
